import AgencyApi from '@/api/agency'

export class AgencyModel {
  constructor(item) {
    const {
      email,
      id,
      name,
      status,
      paymentTerm,
      paymentTermDay,
      systemOwnerId,
      systemOwnerName,
      ownerProfileId,
      anBrokerId,
      defaultAgencyMargin,
      permission,
      salesAccountId,
      salesAccountName,
    } = item
    this.email = email || undefined
    this.id = Number(id) || undefined
    this.name = name || undefined
    this.status = status || undefined
    this.paymentTerm = paymentTerm || undefined
    this.paymentTermDay = paymentTermDay || undefined
    this.systemOwnerId = Number(systemOwnerId) || undefined
    this.systemOwnerName = systemOwnerName
    this.ownerProfileId = ownerProfileId || undefined
    this.anBrokerId = anBrokerId || undefined
    this.defaultAgencyMargin = defaultAgencyMargin || undefined
    this.permission = permission || undefined
    this.salesAccountId = salesAccountId || undefined
    this.salesAccountName = salesAccountName || undefined
  }
  static async searchAgency({
    keyword,
    agencyStatuses,
    minPermissionLevel,
    pageNo,
    pageSize,
    sortKey,
    sortDirection,
  }) {
    const ret = await AgencyApi.searchAgency({
      keyword,
      agencyStatuses,
      minPermissionLevel,
      pageNo,
      pageSize,
      sortKey,
      sortDirection,
    })
    return ret
  }
  // agencyに対して権限があるaccount一覧を取得
  static async getAgencyAccountList(agencyId, params) {
    try {
      return await AgencyApi.fetchAgencyAccountList(agencyId, params)
    } catch (e) {
      console.error(e)
      return []
    }
  }
}

// AgencyAPI.addAgency 用の雛形
export class AddAgencyForm {
  constructor(item = {}) {
    const {
      systemOwnerId,
      name,
      salesAccountId,
      email,
      paymentTerm,
      paymentTermDay,
      defaultAgencyMargin,
    } = item
    this.systemOwnerId = Number(systemOwnerId) || undefined
    this.name = name || undefined
    this.salesAccountId = salesAccountId || undefined
    this.email = email || undefined
    this.status = status || undefined
    this.paymentTerm = paymentTerm || undefined
    this.paymentTermDay = paymentTermDay || undefined
    this.defaultAgencyMargin =
      defaultAgencyMargin != null ? defaultAgencyMargin : undefined
    this.timeZone = 'Asia/Tokyo'
  }
}

// AgencyAPI.editAgency 用の雛形
export class EditAgencyForm {
  constructor(item = {}) {
    const {
      id,
      editedItem,
      name,
      salesAccountId,
      email,
      status,
      paymentTerm,
      paymentTermDay,
      defaultAgencyMargin,
    } = item
    this.id = id || undefined
    this.editedItem = editedItem || undefined
    this.name = name || undefined
    this.salesAccountId = salesAccountId || undefined
    this.email = email || undefined
    this.status = status || undefined
    this.paymentTerm = paymentTerm || undefined
    this.paymentTermDay = paymentTermDay || undefined
    this.defaultAgencyMargin = defaultAgencyMargin || undefined
    this.timeZone = 'Asia/Tokyo'
  }
}
